export const IMAGE_FILE_TYPES = {
  GIF: ".gif",
  JPEG: ".jpeg",
  JPG: ".jpg",
  PNG: ".png",
  SVG: ".svg",
};

export const AUDIO_FILE_TYPES = {
  MP3: ".mp3",
  WAV: ".wav",
  AAC: ".aac",
};

export const OPERATIVE_SYSTEMS = {
  WINDOWS: "Windows",
  MACOS: "MacOS",
  LINUX: "Linux",
};

export const MAX_GAME_CARDS = 16;

export const MIN_GAME_CARDS = 4;

export const MAX_AGE = 150;

export const MIN_AGE = 0;

export const ORIENTATIONS = {
  LANDSCAPE: "landscape",
  PORTRAIT: "portrait",
};

export const TOAST_TYPES = {
  ALERT: "alert",
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
};

export const KEYBOARD_CODES = {
  ENTER_KEY: "Enter",
  ESCAPE_KEY: "Escape",
  SPACE_KEY: "Space",
  LEFT_ARROW_KEY: "ArrowLeft",
  UP_ARROW_KEY: "ArrowUp",
  RIGHT_ARROW_KEY: "ArrowRight",
  DOWN_ARROW_KEY: "ArrowDown",
};

export const PREVIEWS_POSITION = {
  BEFORE: "before",
  AFTER: "after",
};
